module.exports = __webpack_public_path__ + "images/breijer17fc682e6d41067206f3057bdfafe35d.png";